// Generated by GitHub Copilot
import type { ReactNode } from 'react'
import { SearchX } from 'lucide-react'

interface SettingsTableProps {
  /** Header cells (`<th>`) rendered inside the single header `<tr>`. */
  headers: ReactNode
  /** Body rows (`<tr>` elements). */
  children: ReactNode
  /** Bottom-left count label, e.g. "Showing 3 of 10 users". */
  countLabel: string
  /** Shown in place of the table when there are no rows. */
  emptyLabel: string
  isEmpty: boolean
}

/** Shared table shell for the Users & Teams tabs: one table style, uniform row height, and a bottom-left count. */
export function SettingsTable({ headers, children, countLabel, emptyLabel, isEmpty }: SettingsTableProps) {
  return (
    <>
      {isEmpty ? (
        <div className="text-secondary text-center py-5">
          <SearchX size={40} strokeWidth={1.5} className="mb-2 opacity-50" />
          <p className="mb-0">{emptyLabel}</p>
        </div>
      ) : (
        <>
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0 ynt-settings-table">
              <thead>
                <tr>{headers}</tr>
              </thead>
              <tbody>{children}</tbody>
            </table>
          </div>
          <div className="text-secondary small mt-2">{countLabel}</div>
        </>
      )}
    </>
  )
}
